import {Component, OnInit, ViewChild} from '@angular/core';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {FormGroup} from '@angular/forms';
import {
  IBDDiskResults,
  Q_IBD_DISK,
  radarChartData,
  radarChartLabels,
  radarChartOptions,
  radarChartType
} from '../../../../model/questionnaires/questionnaire-ibddisk';
import {MatDialog} from '@angular/material/dialog';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {BaseChartDirective} from 'ng2-charts';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-questionnaire-ibd-disk',
  templateUrl: './questionnaire-ibd-disk.component.html',
  styleUrls: ['./questionnaire-ibd-disk.component.css']
})

export class QuestionnaireIbdDiskComponent implements OnInit {
  toShow: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];  // forse da impostare a -1

  resultToSend: IBDDiskResults;

  // FOR RADAR CHART CONFIG, SEE questionnaire-ibddisk.ts
  radarChartLabels = radarChartLabels;
  radarChartData = radarChartData;
  radarChartType = radarChartType;
  radarChartOptions = radarChartOptions;

  @ViewChild('baseChart') radarChart: BaseChartDirective;

  qForm: FormGroup;
  dataSource = Q_IBD_DISK;
  displayedColumns = ['position', 'question', 'description', 'value'];
  notFocused = false;
  completed = false;
  private found = false;
  submitted = false;
  show = false;

  /// toolbar
  back = true;
  destination = '/questionnaires';
  title = 'IBD-DISK';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;
  sliderValue: number[] = [-1];
  window: any;

  constructor(private questionnaireService: QuestionnaireService,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private router: Router) {
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
    this.window = window;
  }

  selectResult(position: number) {
    this.toShow[position - 1] = this.sliderValue[position - 1];

    console.log('SHOW: ' + this.toShow);
    console.log('DATA: ' + this.radarChartData[0].data);

    console.log(this.radarChartData);

    this.radarChartData[0] = Object.assign({}, this.radarChartData[0], {
      data: this.toShow
    });

    this.reloadChart();

  }

  reloadChart() {
    if (this.radarChart !== undefined) {
      this.radarChart.chart.destroy();
      this.radarChart.chart = null;

      this.radarChart.datasets = this.radarChartData;
      this.radarChart.labels = this.radarChartLabels;
      this.radarChart.ngOnInit();
    }
  }

  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;

    const sorted = [];

    sorted.push(...this.toShow);

    sorted.sort();

    console.log('SORTED: ' + sorted);
    console.log('RADAR: ');

    for (const s of sorted) {
      if (s === -1) {  // TODO: forse da impostare a -1
        const msg = 'Non hai finito di completare il questionario!';
        this.openDialog(msg);
        this.found = true;
        this.show = false;
        this.submitted = false;
        break;
      }
    }

    if (!this.found) {
      this.resultToSend = new IBDDiskResults(this.doctorID, this.patientSSN, this.toShow);
      this.questionnaireService.sendForm(this.resultToSend, 'ibd-disk', this.uuid);
    }
  }

  openDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }
}


